import { useQuery } from '@tanstack/react-query'
import { getPositionById } from 'api/positions/getPositionById'
import { positionsKeys } from './keys'

type UsePositionByIdQueryData = Awaited<ReturnType<typeof getPositionById>>

export const usePositionByIdQuery = (positionId?: number | null) => {
  return useQuery<UsePositionByIdQueryData>({
    queryKey: positionsKeys.detail(positionId ?? undefined),
    queryFn: () => {
      if (positionId == null) {
        throw new Error('Position ID is required')
      }
      return getPositionById(positionId)
    },
    enabled: positionId != null,
  })
}
